(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weekly-specials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('.nwt-deals');
    sections.forEach(function(section) {
      // Tab switching
      var tabs = section.querySelectorAll('.nwt-deals__tab');
      var panels = section.querySelectorAll('.nwt-deals__panel');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.getAttribute('data-tab-target');

          tabs.forEach(function(t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function(p) {
            if (p.getAttribute('data-tab-panel') === target) {
              p.classList.add('is-active');
              p.removeAttribute('hidden');
            } else {
              p.classList.remove('is-active');
              p.setAttribute('hidden', '');
            }
          });
        });
      });

      // Countdown timer
      var endDate = section.getAttribute('data-end-date');
      var endTime = section.getAttribute('data-end-time') || '23:59';
      var timerEl = section.querySelector('[data-timer]');

      if (!endDate || !timerEl) return;

      var liveEl = section.querySelector('[data-timer-live]');
      var expiredEl = section.querySelector('[data-timer-expired]');
      var daysEl = section.querySelector('[data-days]');
      var hoursEl = section.querySelector('[data-hours]');
      var minutesEl = section.querySelector('[data-minutes]');
      var secondsEl = section.querySelector('[data-seconds]');

      var target = new Date(endDate + 'T' + endTime + ':00').getTime();
      if (isNaN(target)) return;

      function pad(n) { return n < 10 ? '0' + n : '' + n; }

      function tick() {
        var now = new Date().getTime();
        var diff = target - now;

        if (diff <= 0) {
          if (liveEl) liveEl.hidden = true;
          if (expiredEl) expiredEl.hidden = false;
          clearInterval(interval);
          return;
        }

        var days = Math.floor(diff / (1000 * 60 * 60 * 24));
        var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((diff % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      tick();
      var interval = setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
